import React from 'react';
import { Link } from 'react-router-dom';

const CTAButton = ({ to, children, primary = true, target, rel }) => {
  const ButtonComponent = to && !to.startsWith('http') ? Link : to ? 'a' : 'button';
  const props = {};
  
  if (to && !to.startsWith('http')) {
    props.to = to;
  } else if (to) {
    props.href = to;
    if (target) props.target = target;
    if (rel) props.rel = rel;
  }
  
  return (
    <ButtonComponent
      {...props}
      className={`cta-button ${primary ? 'cta-primary' : 'cta-secondary'}`}
    >
      {children}
    </ButtonComponent>
  );
};

export default CTAButton;
